import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import * as echarts from "echarts";
import { newRoleCount, onlineUserCount } from "@/api/data";
export default {
  name: "SelectAccmuLine",
  props: {
    sendTimeArrData: {
      type: Array
    },
    serverID: {
      type: Array
    }
  },
  watch: {
    // sendTimeArrData(newVal) {
    //     if (newVal) {
    //         this.initTime();
    //     }
    // },
    // serverID(newVal) {
    //     if (newVal) {
    //         this.initTime();
    //     }
    // },
  },
  data: function data() {
    return {
      //重新赋值
      sendTimeArr: [],
      //当前时间的数组
      RoleArrTime: [],
      //当前数量的数组
      RoleArrNum: [],
      //拿选中的俩个日期的前一天
      sendBeforeTimeArr: [],
      roleTimeNow: "",
      onLineTimeNow: "",
      TimeTitle: [],
      startValue: "",
      endValue: ""
    };
  },
  methods: {
    initTime: function initTime() {
      if (this.sendTimeArrData) {
        this.sendTimeArr = this.sendTimeArrData; //['2021-10-12', '2021-10-13']
        this.startValue = this.sendTimeArrData[0];
        this.endValue = this.sendTimeArrData[1];
        this.getDateTime();
      } else {
        this.sendTimeArr = [this.getNextDate(), this.getNowtDate()];
        this.sendBeforeTimeArr = [this.getNextDate(this.sendTimeArr[0]), this.getNextDate(this.sendTimeArr[1])];
        this.startValue = this.getNextDate();
        this.endValue = this.getNowtDate();
        this.getDateTime();
      }
    },
    defaultTime: function defaultTime() {
      return [this.getNextDate(), this.getNowtDate()];
    },
    getNextDate: function getNextDate(data) {
      var dd = "";
      if (data) {
        dd = new Date(data); //Thu Oct 14 2021 16:28:17 GMT+0800 (中国标准时间)
      } else {
        dd = new Date();
      }
      dd.setDate(dd.getDate() - 1);
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    getNowtDate: function getNowtDate() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
    getDateTime: function getDateTime() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getOnlineArr();
            case 2:
              _context.next = 4;
              return _this.getRoleArr();
            case 4:
              _this.TimeTitle.push("实时在线", "实时创角");
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getOnlineArr: function getOnlineArr() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var i, k;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.OnLineArrNum = [];
              _this2.OnLineArrTime = [];
              _this2.onLineTimeNow = "";
              if (!(_this2.sendTimeArr[0] === _this2.sendTimeArr[1])) {
                _context2.next = 10;
                break;
              }
              _context2.next = 6;
              return onlineUserCount({
                sdate: _this2.sendTimeArr[0],
                edate: _this2.sendTimeArr[1],
                grouping: "minute",
                server_id: _this2.serverID
              });
            case 6:
              _this2.onLineTimeNow = _context2.sent;
              for (i = 0; i < _this2.onLineTimeNow.data.length; i++) {
                _this2.OnLineArrTime.push(_this2.onLineTimeNow.data[i].time);
                _this2.OnLineArrNum.push(_this2.onLineTimeNow.data[i].num);
              }
              _context2.next = 14;
              break;
            case 10:
              _context2.next = 12;
              return onlineUserCount({
                sdate: _this2.sendTimeArr[0],
                edate: _this2.sendTimeArr[1],
                grouping: "hour",
                server_id: _this2.serverID
              });
            case 12:
              _this2.onLineTimeNow = _context2.sent;
              for (k = 0; k < _this2.onLineTimeNow.data.length; k++) {
                _this2.OnLineArrTime.push(_this2.onLineTimeNow.data[k].date + " " + _this2.onLineTimeNow.data[k].time);
                _this2.OnLineArrNum.push(_this2.onLineTimeNow.data[k].num);
              }
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getRoleArr: function getRoleArr() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var i, k;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.RoleArrTime = [];
              _this3.RoleArrNum = [];
              _this3.roleTimeNow = "";
              if (!(_this3.sendTimeArr[0] === _this3.sendTimeArr[1])) {
                _context3.next = 10;
                break;
              }
              _context3.next = 6;
              return newRoleCount({
                sdate: _this3.sendTimeArr[0],
                edate: _this3.sendTimeArr[1],
                grouping: "minute",
                server_id: _this3.serverID
              });
            case 6:
              _this3.roleTimeNow = _context3.sent;
              for (i = 0; i < _this3.roleTimeNow.data.length; i++) {
                _this3.RoleArrTime.push(_this3.roleTimeNow.data[i].time);
                _this3.RoleArrNum.push(_this3.roleTimeNow.data[i].num);
              }
              _context3.next = 14;
              break;
            case 10:
              _context3.next = 12;
              return newRoleCount({
                sdate: _this3.sendTimeArr[0],
                edate: _this3.sendTimeArr[1],
                grouping: "hour",
                server_id: _this3.serverID
              });
            case 12:
              _this3.roleTimeNow = _context3.sent;
              for (k = 0; k < _this3.roleTimeNow.data.length; k++) {
                _this3.RoleArrTime.push(_this3.roleTimeNow.data[k].date + " " + _this3.roleTimeNow.data[k].time);
                _this3.RoleArrNum.push(_this3.roleTimeNow.data[k].num);
              }
            case 14:
              _this3.initCharts();
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    //x轴去重
    dupRepeat: function dupRepeat(arr) {
      if (!Array.isArray(arr)) {
        return;
      }
      return Array.from(new Set(arr));
    },
    initCharts: function initCharts() {
      var chartDom = document.getElementById("mainOne");
      var myChartOne = echarts.init(chartDom);
      this.option && myChartOne.setOption(this.option);

      // 绘制图表
      myChartOne.setOption({
        title: {
          text: "实时在线+创角人数"
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.TimeTitle
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          name: "时间",
          data: this.RoleArrTime.length > this.OnLineArrTime.length ? this.RoleArrTime : this.OnLineArrTime
        },
        yAxis: {
          type: "value",
          name: "人数"
        },
        dataZoom: [{
          // startValue: this.startValue,
          // endValue: this.endValue,
          type: "inside",
          show: true
        }, {
          type: "inside"
        }],
        series: [{
          name: "实时在线",
          type: "line",
          data: this.OnLineArrNum
        }, {
          name: "创角人数",
          type: "line",
          data: this.RoleArrNum
        }]
      });
    }
  },
  mounted: function mounted() {
    this.initTime();
  }
};